import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const totalValues = this.props.totalValues;
        const collectionCategoryReport = this.props.collectionCategoryReport

        return (
            <div>
                <h3><center><u>Good Leaf Percentage Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division === undefined ? "All Divisions" : searchData.division}</div>
                    <div className="col"><b>Feild: </b> {searchData.feild === undefined ? "All Fields" : searchData.feild}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Field</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Bag Count</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Net Amount</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Percentage %</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {collectionCategoryReport.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell component="th" scope="row" align="center"> {row.fieldName}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.bagCount}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.netAmount}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.percentage}</TableCell>
                                </TableRow>
                            )
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}